import React, { useEffect, useState, useRef } from "react";

import Modal from "react-modal";

import CancelIcon from "../../assets/cancel_icon.svg";
import AddSocialModalComponent from './AddSocialModalComponent';
import ShowSocialSuccessModalComponent from './ShowSocialSuccessModalComponent';

const SHOW_ADD_SOCIAL = 1;
const SHOW_SUCCESS = 2;



function useForceUpdate(){
    const [value, setValue] = useState(0); // integer state
    return () => setValue(value => value + 1); // update the state to force render
}

export default function AddSocialManagerComponent(props:any){    
    const currDisplayedComp = useRef(SHOW_ADD_SOCIAL);
    const [isOpen, setIsOpen] = useState(props.isOpen);
    const forceUpdate = useForceUpdate();

    useEffect(()=>{
        console.log('killlllll')
        setIsOpen(props.isOpen);
    },[props.isOpen])

    
    const handleModalCloseEvent = () => {
        setIsOpen(false);
        props.handleModalCloseEvent();
    }

    const moveToSuccess = ()=> {
        console.log('move to add card called');
        currDisplayedComp.current = SHOW_SUCCESS;
        forceUpdate();
    }

    
    return (
        <>
            {(currDisplayedComp.current === SHOW_ADD_SOCIAL) && (
                <AddSocialModalComponent
                    isOpen={isOpen}
                    handleModalCloseEvent={handleModalCloseEvent}
                    moveToSuccess={()=>{moveToSuccess()}}
                >
                </AddSocialModalComponent>
            )}
            {(currDisplayedComp.current === SHOW_SUCCESS) && (
                <ShowSocialSuccessModalComponent
                    isOpen={isOpen}
                    handleModalCloseEvent={handleModalCloseEvent}
                >
                </ShowSocialSuccessModalComponent>
            )}
        </>
    );
}
